import FizConfig from "./FizConfig.ts";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import * as amplify from "./util/amplify.ts";
import * as libLocation from "./lib/location.ts";
import Handlebars from "./lib/handlebars/handlebars.js?amd";
import * as deltatime from "./lib/deltatime.ts";
import * as DateUtils from "./lib/DateUtils.ts";
import {isFeatureEnabled} from "./lib/launchdarkly/launchdarkly.ts";
import Icons from "./svg/Icons.ts";
import { protoExtendDefaults } from "./lib/ObjectUtil.ts";
  var
    // Private field
    templatesByName: Record<string, any> = {},
    i18nTemplateByContent: Record<string, any> = {};

  /*
    Function: addTemplate(name,text)
    Define a template with given name for use in Mustache engine

    Parameter:
      name - string, the name of the template
      text - string, the text of the template
  */
  function addTemplate(name: string, text: string | Function | any): string {
    if(!templatesByName[name]){
      var template: any;
      if(typeof text==='string'){
        template = Handlebars.compile(text)
      }else if(typeof text==='function'){
        template = text;
      }else{
        template = Handlebars.template(text)
      }
      Handlebars.registerPartial(name,template);
      templatesByName[name] = template;
    }
    return "MUS!"+name;
  }

  function i18ntemplate(key: string, ctx?: any, doNotEscape?: boolean): string {
    var
      template = i18n.get(key,ctx),
      templateFunction = i18nTemplateByContent[template];
    if(!templateFunction){
      try{
        templateFunction = i18nTemplateByContent[template] = Handlebars.compile(template,{noEscape:!!doNotEscape});
      }catch(e){
        console.log(key,ctx,template);
        console.log(e);
      }
    }
    try{
      return templateFunction(ctx,{allowProtoPropertiesByDefault:true,allowProtoMethodsByDefault :true});
    }catch(e){
      console.log(e);
      return key;

    }
  }
  function i18nHelper(this: any, contextOrOption: any, isContext: boolean): string {
    try{
      return i18ntemplate(isContext?contextOrOption:contextOrOption.fn(this),this);
    }catch(e){
      console.log(contextOrOption, isContext)
      return "error.key"
    }
  }
  
  /*
    Function: transform(template, view): string
    Apply the given Mustache template to given data (view)

    Parameters are replaced with properties found in view; in addition, key
    names may be wrapped in i18n sections to insert translations:
    {{#i18n}}section.key{{/i18n}} and URLs are detected in the text of
    {{#urlText}} sections and replaced with HTML links.

    See mustache(5) for details of Mustache template processings:
    http://mustache.github.com/mustache.5.html

    Parameters:
      template - string, the template string in Mustache format
      view - object, optional, data with parameters to replace in the template,
        defaults to {} to replace only localization keys

    Returns:
      string, the HTML or text resulting from the transformation
  */
  function transform(template: string | Function, view?: any): string {
    //the view datas take precedence over the global context (familyName, family, locale...)
    view = protoExtendDefaults(view,mustacheContext);

    try{
      var tpl = typeof template === 'string'?Handlebars.compile(template):template;
      return tpl(view,{allowProtoPropertiesByDefault:true,allowProtoMethodsByDefault :true});
    } catch(e){
      console.log(e);
      console.log("template : ",template);
      throw e;
    }
  }
  function mustache(templateName: any, datas?: any): string {
    if(typeof templateName === 'function'){
      return templateName(datas).toHTML();
    }
    //when loaded as Module
    if(templateName.default){
      templateName = templateName.default;
    }
    if(templateName.indexOf('MUS!')===0){
      templateName = templateName.substring(4);
    }
    if (templatesByName[templateName] === undefined ){
      console.log("Mustache template not found: "+templateName);
      return;
    }
    try{
      return transform(templatesByName[templateName],datas);
    } catch(e){
      console.error("Error on template : "+templateName);
      throw e;
    }
  }
  export function mustacheoverride(overide: Record<string, string>, call: () => void): void {
    var old = Object.assign({},Handlebars.partials)
    try{
      for(var [name,value] of Object.entries(overide)){
        Handlebars.registerPartial(name,Handlebars.compile(value));
      }
      call()
    }finally{
      Handlebars.partials = old;
    }

  }
  Handlebars.registerHelper('tpl',function (this: any, val: string) {
    return new Handlebars.SafeString(mustache(val,this));
  });
  Handlebars.registerHelper('iconlib',function (val: string, color?: string) {
    var
      crawler: any = Icons;
    for(var part of val.split('.')){
      crawler = crawler[part];
      if(crawler===undefined){
        console.log(new Error('cannot find icon '+val))
        return ''
      }
    }
    if(typeof color==='string'){
      crawler = crawler.withColor(color);
    }
    return crawler;
  });
  Handlebars.registerHelper('iconliburl',function (val: string, color?: string) {
    var
      crawler: any = Icons;
    for(var part of val.split('.')){
      crawler = crawler[part];
      if(crawler===undefined){
        console.log(new Error('cannot find icon '+val))
        return ''
      }
    }
    if(typeof color==='string'){
      crawler = crawler.withColor(color);
    }
    return crawler.toURL();
  });
  Handlebars.registerHelper('iso',function (val?: Date) {
    if(val)
      return val.toISOString();
    else
      return '$empty'
  });
  Handlebars.registerHelper('isonotime',function (val?: Date) {
    if(val)
      return val.toISOString().substring(0,10);
  });
  Handlebars.registerHelper('dateinput',function (val: any) {
    try{
      return new Handlebars.SafeString(DateUtils.forInputDate(val));
    }catch(e){
      console.log(e)
    }
  });
  Handlebars.registerHelper('datetimeinput',function (date: any) {
    try{
      return new Handlebars.SafeString(DateUtils.forInputDateTimeLocal(date));
    }catch(e){
      console.log(e)
    }
  });
  Handlebars.registerHelper('i18nNum',function (key: string, val: any) {
    return new Handlebars.SafeString(i18n.get(key,val));
  });
  Handlebars.registerHelper('i18n',i18nHelper);
  Handlebars.registerHelper('i18nDyn',i18nHelper);
  Handlebars.registerHelper('i18nsimple',function(key: string, ctx?: any) {
    return new Handlebars.SafeString(i18n.get(key,ctx));
  });
  Handlebars.registerHelper('birthMaxDate',function(){
    return DateUtils.forInputDate(new Date());
  });
  Handlebars.registerHelper('imageUri',function(uri: string, w: number, h: number, s: string){
    if(uri.indexOf(FizConfig.API_BASE_URL)!==0){
      return uri;
    }
    if(uri.indexOf('?')===-1){
      uri+='?'
    }else{
      uri+='&';
    }
    return uri+'w='+w+'&h='+h+'&s='+s;
  });


  Handlebars.registerHelper('log',function(param: any) {
    console.log(param);
  });
  Handlebars.registerHelper('user',function(options: any) {
    return options.fn(FwDatas.getUser());
  });
  Handlebars.registerHelper('textareaescape',function(data?: string) {
    if(data){
      return new Handlebars.SafeString(data.replace('<','&lt;').replace('>','&gt;'));
    }
  });
  Handlebars.registerHelper('deltatime',function(this: any, date: Date | string, format?: string, extraCss?: string) {
    if(typeof date==='string'){
      format = date;
      date = new Date();
    }
    if(typeof extraCss!=='string'){
      extraCss="";
    }
    return new Handlebars.SafeString(deltatime.html(date as Date,typeof format==='string'?format:'longdate',extraCss));
  });
  Handlebars.registerHelper('deltatimeraw',function(date: Date) {
    return deltatime.deltatime.longdate(date);
  });
  Handlebars.registerHelper('longDate',function(date: Date | string, format?: string) {
    if(!(date instanceof Date)){
      date = new Date(date);
    }
    if(date===null){
      return '';
    }

    return DateUtils.format(date as Date,typeof format==='string'?format:'dddd LL');
  });

  var
    splash = Math.floor(Math.random()*5)
  Handlebars.registerHelper('$splash',function(this: any, context?: any){
    splash = (splash +1)%5;
    this["splash0"+(splash+1)] = true;
  });

  Handlebars.registerHelper('var',function(this: any, name: string, value: any, context?: any){
    if(arguments.length===3){
      this[name] = value;
    }else{
      this[name] = value.fn(this)
    }
  });

  Handlebars.registerHelper('personLink',function(this: any, options: any) {
    if(!this.person){
      return '';
    }
    if(!this.person.accountId){
      return options.fn(this);
    }
    return '<a data-fw-onclick="modaluser|'+encodeURIComponent(this.person.accountId)+'">'+options.fn(this)+'</a>';
  });

  Handlebars.registerHelper('placeLink',function(this: any, options: any) {
    try {
      return '<a href="map.php?placeId=' + encodeURIComponent(this.place.placeId) + '">'  + options.fn(this) + '</a>';
    } catch (e) {
      console.log("no place in object",this);
      return options.fn(this);
    }
  });
  Handlebars.registerHelper('familyLink',function(this: any, options: any) {
    return '<a href="settings.php">'+options.fn(this)+'</a>';
  });

  Handlebars.registerHelper('premiumPermission',function(this: any, permissionName: string | Function, options?: any) {
    if(typeof permissionName==='function'){
      permissionName = permissionName.apply(this)
    }
    var
      data = FwDatas.getPermission(permissionName as string);
    //if it is a if {{#permissionName
    if(options && options.fn){
      if(data && data!=='KO_PREMIUM'){
        return options.fn(this);
      }else{
        return options.inverse(this);
      }
    //if it a direct call {{permissionName
    }else{
      return data;
    }

  });
  Handlebars.registerHelper('isFeatureEnabled',function(this: any, flagName: string) {
    var options = arguments[arguments.length-1];
    if(isFeatureEnabled(flagName as any)){
      return options.fn(this);
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('if-or',function(this: any) {
    var options = arguments[arguments.length-1];
    for(var i=0;i<arguments.length-1;i++){
      var value = arguments[i];
      // Si c'est une fonction, l'évaluer avec le contexte actuel
      if(typeof value === 'function'){
        value = value.apply(this);
      }
      if(value){
        return options.fn(this);
      }
    }
    return options.inverse(this);
  });
  Handlebars.registerHelper('if-and',function(this: any) {
    var options = arguments[arguments.length-1];
    for(var i=0;i<arguments.length-1;i++){
      var value = arguments[i];
      // Si c'est une fonction, l'évaluer avec le contexte actuel
      if(typeof value === 'function'){
        value = value.apply(this);
      }
      if(!value){
        return options.inverse(this);
      }
    }
    return options.fn(this);
  });
  Handlebars.registerHelper('if-eq',function(this: any) {
    var options = arguments[arguments.length-1];
    var val = arguments[0];
    // Si c'est une fonction, l'évaluer avec le contexte actuel
    if(typeof val === 'function'){
      val = val.apply(this);
    }
    for(var i=1;i<arguments.length-1;i++){
      var compareVal = arguments[i];
      // Si c'est une fonction, l'évaluer avec le contexte actuel
      if(typeof compareVal === 'function'){
        compareVal = compareVal.apply(this);
      }
      if(val != compareVal){
        return options.inverse(this);
      }
    }
    return options.fn(this);
  });
  Handlebars.registerHelper('if-more',function(this: any) {
    var options = arguments[arguments.length-1];
    var val1 = arguments[0];
    var val2 = arguments[1];
    // Si c'est une fonction, l'évaluer avec le contexte actuel
    if(typeof val1 === 'function'){
      val1 = val1.apply(this);
    }
    if(typeof val2 === 'function'){
      val2 = val2.apply(this);
    }
    if(val1 > val2){
      return options.fn(this);
    }else{
      return options.inverse(this);
    }
  });
  Handlebars.registerHelper('if-page',function(this: any) {
    var
      options = arguments[arguments.length-1],
      page = libLocation.getPageName();

    for(var i=0;i<arguments.length-1;i++){
      var pageToCompare = arguments[i];
      // Si c'est une fonction, l'évaluer avec le contexte actuel
      if(typeof pageToCompare === 'function'){
        pageToCompare = pageToCompare.apply(this);
      }
      if(pageToCompare === page){
        return options.fn(this);
      }
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('FizConfig',function(this: any){
    var options = arguments[arguments.length-1];
    return options.fn(FizConfig);
  });
  Handlebars.registerHelper('families',function(){
    return FwDatas.getFamilies();
  });
  Handlebars.registerHelper('invitations',function(){
    return FwDatas.getInvitations();
  });
  Handlebars.registerHelper('notifcount',function(this: any, options: any){
    var count = FwDatas.getInvitations().length;
    FwDatas.getFamilies().forEach((fam: any)=>count+= fam.wallCounter)
    if(count>0) return options.fn(count);
  });

  Handlebars.registerHelper('family',function(this: any){
    var options = arguments[arguments.length-1];
    // Si un family existe dans le contexte courant, l'utiliser
    var familyData = FwDatas.getFamily();
    if(this.family){
		if(typeof this.family === 'function'){
			familyData = this.family()
		}else{
			familyData = this.family
		}
    }

    return options.fn(familyData);
  });
  Handlebars.registerHelper('monofamily',function(){
    return FwDatas.getFamilies().length===1;
  });
  Handlebars.registerHelper('totalNotifCount',function(this: any){
    var res = FwDatas.getInvitations().filter(function(o: any){
      return o.blockingStatus!=="BlockedShown";
    }).length;
    FwDatas.getFamilies().forEach(function(fam: any){
      res += fam.wallCounter;
    });
    if(res){
      var options = arguments[arguments.length-1];
      return options.fn(res);
    }
  });

  var mustacheContext: any = {
      FizConfig : FizConfig,
      FwDatas:FwDatas,
      'false':false,
      'true':true,
      family : function(){
        return FwDatas.getFamily();
      },
      familyName : function(){
        var family = FwDatas.getFamily();
        if(family){
          return family.name;
        }
      },
      incomingInvitations : function(){
        return FwDatas.getInvitations().filter(function(o: any){
          return o.blockingStatus!=="BlockedShown";
        });
      },
      locale: function() {
        return i18n.getSelectedLanguage();
      }
  };

  addTemplate("authorLink",'<a style="word-break: break-word;" data-fw-onclick="modaluser|{{accountId}}">{{#author}}<b>{{name}}</b>{{/author}}</a>');
  addTemplate("listLink",'<a href="tasks.php?metaId={{nested.metaId}}" class="color-branded"><b>{{nested.name}}</b></a>');

  var
    registerHelper = function(a: string, b: any, c?: any): void {
      Handlebars.registerHelper(a,b,c)
    },
    SafeString = Handlebars.SafeString;

  export {
    addTemplate,
    transform,
    mustache,
    mustacheContext,
    i18ntemplate as i18n,
    SafeString,
    registerHelper
  }
